import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BRAND } from '@/config/brand';

const ROUTE_TITLES = {
  '/login': 'Login',
  '/display': 'Gate Display',
  '/_kit': 'Design System Kit',
  '/notifications': 'Notifications',
  '/profile': 'My Profile',
  '/principal/overview': 'Principal Overview',
  '/principal/students': 'Students Directory',
  '/principal/teachers': 'Faculty Directory',
  '/principal/attendance': 'Campus Attendance',
  '/principal/devices': 'Biometric Devices',
  '/principal/fees': 'Fees & Invoicing',
  '/principal/academics': 'Academics & Timetable',
  '/principal/leaves': 'Leave Applications',
  '/principal/notices': 'Notice Board',
  '/principal/chat': 'Institutional Chat',
  '/principal/events': 'Academic Calendar',
  '/teacher/today': 'Teacher Dashboard',
  '/teacher/attendance': 'Class Attendance',
  '/teacher/students': 'My Students',
  '/teacher/homework': 'Homework & Tasks',
  '/teacher/marks': 'Examination Marks',
  '/teacher/leaves': 'Leave Management',
  '/teacher/notices': 'Staff Notices',
  '/teacher/chat': 'Teacher Chat',
  '/student/home': 'Student Portal',
  '/student/attendance': 'Attendance Record',
  '/student/homework': 'My Homework',
  '/student/results': 'Report Card',
  '/student/fees': 'Fee Ledger',
  '/student/timetable': 'Class Timetable',
  '/student/notices': 'Student Notices',
  '/student/chat': 'Class Chat',
  '/parent/home': 'Parent Portal',
  '/parent/attendance': 'Ward Attendance',
  '/parent/fees': 'Fee Settlement',
  '/parent/results': 'Academic Progress',
  '/parent/homework': 'Assigned Homework',
  '/parent/timetable': 'Ward Timetable',
  '/parent/notices': 'School Circulars',
  '/parent/chat': 'Parent-Teacher Chat'
};

export function useDocumentTitle() {
  const location = useLocation();

  useEffect(() => {
    let title = ROUTE_TITLES[location.pathname];
    if (!title) {
      if (location.pathname.startsWith('/principal/students/')) {
        title = 'Student Profile';
      } else {
        const seg = location.pathname.split('/').filter(Boolean).pop();
        title = seg ? seg.charAt(0).toUpperCase() + seg.slice(1) : 'Home';
      }
    }
    document.title = `${title} · ${BRAND.productName}`;
  }, [location.pathname]);
}
